import { render, staticRenderFns } from "./NicheDetail.vue?vue&type=template&id=a1d288b8"
import script from "./NicheDetail.vue?vue&type=script&lang=js"
export * from "./NicheDetail.vue?vue&type=script&lang=js"
import style0 from "./NicheDetail.vue?vue&type=style&index=0&id=a1d288b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports